var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUnExpand = function SvgUnExpand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "unExpand_svg__\\u6D41\\u7A0B",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "unExpand_svg__\\u8BC4\\u8BBA",
    transform: "translate(-1380.000000, -72.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "unExpand_svg__\\u77E9\\u5F62",
    transform: "translate(258.000000, 56.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "unExpand_svg__\\u7F16\\u7EC4-3",
    transform: "translate(1124.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "unExpand_svg__\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }), /*#__PURE__*/React.createElement("g", {
    id: "unExpand_svg__\\u7F16\\u7EC4-2",
    transform: "translate(7.021689, 8.978311) rotate(-315.000000) translate(-7.021689, -8.978311) translate(2.071942, 3.997890)",
    fill: "#78808D",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.83114099,-0.720000722 C10.1956796,-0.723514114 10.4995679,-0.455522904 10.550609,-0.104518855 L10.5581159,-0.00687395083 L10.6194956,6.41843327 C10.6232585,6.81606017 10.3039958,7.14147803 9.90636889,7.14530792 C9.54187757,7.14875442 9.23806189,6.88077506 9.18703296,6.52981371 L9.17952775,6.43218117 L9.125,0.726 L3.54254166,0.781312089 C3.17805099,0.784859841 2.87418552,0.516936944 2.82309136,0.165985081 L2.81553318,0.0683539457 C2.81202026,-0.296136724 3.07994316,-0.600002195 3.43089502,-0.651096352 L3.52852615,-0.658619703 L9.83114099,-0.720000722 Z",
    id: "unExpand_svg__\\u76F4\\u7EBF-2\\u5907\\u4EFD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.29560708,2.81553318 C6.66014565,2.81201979 6.96403397,3.080011 7.01507506,3.43101505 L7.02258202,3.52865996 L7.08396173,9.95396718 C7.08772459,10.3515941 6.76846188,10.6770119 6.37083498,10.6808418 C6.00634366,10.6842883 5.70252798,10.416309 5.65149905,10.0653476 L5.64399384,9.96771508 L5.589,4.262 L0.0070077528,4.31684599 C-0.357482917,4.32039375 -0.661348388,4.05247085 -0.712442545,3.70151899 L-0.720000722,3.60388785 C-0.723513648,3.23939718 -0.455590751,2.93553171 -0.104638888,2.88443755 L-0.0070077528,2.8769142 L6.29560708,2.81553318 Z",
    id: "unExpand_svg__\\u76F4\\u7EBF-2\\u5907\\u4EFD"
  }))))))));
};
export default SvgUnExpand;